/**
 * Blacklist de conteúdo proibido em formulários (mensagens, nomes de oferta,
 * textos de botão, mensagens de entrega, etc).
 *
 * Objetivo: impedir o cadastro de conteúdo relacionado a exploração/abuso
 * sexual de menores/animais, seja por termos explícitos/codificados ou por
 * combinações de emojis/palavras que sugerem esse tipo de conteúdo.
 *
 * Para adicionar novos termos/emojis, basta editar as listas abaixo.
 */

// Termos/expressões bloqueados em qualquer contexto (match por prefixo,
// então "pedofil" também bloqueia "pedofilia", "pedófilo" etc).
export const BLACKLISTED_TERMS = [
    'teen',
    'underage',
    'todas as idades',
    'com 16',
    '16 anos',
    '17 anos',
    '15 anos',
    '14 anos',
    '13 anos',
    '12 anos',
    '11 anos',
    '10 anos',
    '9 anos',
    '8 anos',
    '7 anos',
    '6 anos',
    '5 anos',
    '4 anos',
    '3 anos',
    '2 anos',
    '1 ano',
    '0 anos',
    'pre-adolescente',
    'adolescente',
    'juventude',
    'ninfeta',
    'menininh',
    'recém-nascido',
    'child exploitation',
    'abuso sexual',
    'abuso',
    'menina',
    'cp',
    'menino',
    'kids',
    'animalesco',
    'animalesca',
    'ninfetinho',
    'ninfetinha',
    'ninfetinh',
    'ninfet',
    'pedofil',
    'bebê',
    'neném',
    'loli',
    'lolita',
    'escola',
    'escolinha',
    'colegial',
    'colegialinha',
    'colegialh',
    'mirim',
    'pedofilia',
    'pedófil',
    'hebefil',
    'lolicon',
    'shotacon',
    'incesto infantil',
    'porno com crianca',
    'shota',
    'jailbait',
    'csam',
    'pthc',
    'cheese pizza',
    'cheesepizza',
    'menor de idade',
    'menor de 18',
    'menores',
    'menor pelad',
    'nude infantil',
    'infantil nude',
    'nudes de menor',
    'nude de menor',
    'child porn',
    'childporn',
    'child',
    'sub18',
    'sub17',
    'sub16',
    'sub15',
    'sub14',
    'sub13',
    'sub12',
    'sub10',
    'sub11',
    'sub 11',
    'sub 10',
    'sub 12',
    'sub 13',
    'sub 14',
    'trafico',
    'traficado',
    'traficada',
    'abuso',
    'estrupro',
    'estrupo',
    'estrupar',
    'estruprar',
    'nazi',
    'tráfico infantil',
    'exploração',
    'estuprando',
    'estruprando',
    'violentando',
    'estupro',
    'violência',
    'ncc',
    'não consensual',
    'ncc',
    'sem consentimento',
    'sub 15',
    'sub 16',
    'sub 17',
    'sexting infantil',
    'vulnerável',
    'sub 18',
    'crianca',
    'criança',
    'infantil',
    'colegial',
    'mirim',
    'novinha',
    'novinho',
    'novinh',
    '-18',
    '- 18',
    '<18',
    '< 18',
    '👶', '🧒', '👧', '👦', '🎒', '🧸', '🍼', '🦄', '🎒', '🛝', '🎠', '🐶', '🐄', '🐮', '🍭', '🍬'
];


/**
 * Remove tags HTML, acentos e normaliza para minúsculas, para facilitar
 * a comparação com a blacklist.
 */
const normalize = (text) => {
    return (text || '')
        .toString()
        .replace(/<[^>]*>/g, ' ')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
};

const escapeRegex = (term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const containsTerm = (normalizedText, term) => {
    const escaped = escapeRegex(term);
    // \b só funciona em transições de caractere de palavra (\w). Termos que
    // começam com algo que não é \w (emojis, "-18", "<18" etc.) nunca
    // bateriam com \b no início, então nesses casos comparamos por substring.
    const pattern = /^\w/.test(term) ? `\\b${escaped}` : escaped;
    return new RegExp(pattern, 'i').test(normalizedText);
};

/**
 * Valida um texto contra a blacklist.
 * @param {string} text
 * @returns {{ isValid: boolean, error: string|null, matches: string[] }}
 */
export const validateContent = (text) => {
    if (!text) {
        return { isValid: true, error: null, matches: [] };
    }

    const normalized = normalize(text);

    const directMatches = BLACKLISTED_TERMS.filter((term) => containsTerm(normalized, term));
    if (directMatches.length > 0) {
        return {
            isValid: false,
            error: 'Conteúdo não permitido encontrado. Não é permitido conteúdo relacionado a exploração ou abuso de menores/animais.',
            matches: directMatches,
        };
    }


    return { isValid: true, error: null, matches: [] };
};

/**
 * Valida múltiplos campos de um formulário.
 * @param {{ label: string, value: string }[]} fields
 * @returns {{ isValid: boolean, error: string|null }}
 */
export const validateFields = (fields) => {
    for (const field of fields) {
        const result = validateContent(field.value);
        if (!result.isValid) {
            return {
                isValid: false,
                error: `${result.error} (Campo: "${field.label}"): TERMO(S) ENCONTRADO(S): ${result.matches.join(', ')}`,
            };
        }
    }

    return { isValid: true, error: null };
};
